import { createContext } from 'react';

/** Matches the Scope column on dbo.DashPage and dbo.DashProcedure. */
export type DashScope = 'project' | 'consultant' | 'consultantPortfolio';

export interface DashScopeValue {
    scope: DashScope;
    /** Merged into every widget's procedure params; SQL reads them with JSON_VALUE(@JsonIn, '$.<key>'). */
    params: Record<string, string>;
}

/**
 * Lets a host outside a project (e.g. the Consultant Dash) reuse DashGrid with its own pages,
 * procedures and params, without threading props through DashGrid → DashCard → DashItemLoader.
 */
export const DashScopeContext = createContext<DashScopeValue>( { scope: 'project', params: {} } );
